import React from 'react';
import '../../stylesheets/app_loading.scss';

export default function AppLoading({label = 'Loading', variant = 'panel'}) {
  return <div className={`appLoading appLoading-${variant}`} role="status" aria-busy="true" aria-label={label}>
    <span className="appLoadingLabel">{label}</span>
    <div className="appLoadingShapes" aria-hidden="true">
      <div className="appLoadingHeading"/>
      {[0,1,2].map(row => <div className="appLoadingRow" key={row}><i/><div><b/><b/></div></div>)}
    </div>
  </div>;
}
export function AppLoadError({retry, label = 'We couldn’t load this information.'}) {
  return <div className="appLoadError" role="alert"><p>{label}</p><button type="button" onClick={retry}>Try again</button></div>;
}
